<template>
  <cube-popup type="extend-popup" ref="popup">
    <div class="cube-extend-popup-content" @click="hide">
      <h1 class="title">投保申明</h1>
      <pre class="content">
上海和与合信息科技有限公司作为深圳市慧择保险经纪有限公司的第三方合作伙伴，在其旗下斑马邦APP和斑马邦微信公众号平台内向用户推广深圳市慧择保险经纪有限公司提供的保险产品及服务。请用户在投保前务必阅读以下投保申明：

  1. 投保时，本投保人已就该产品的保障内容以及保险金额向被保险人进行了明确说明，并征得其同意。
  2. 本投保人授权深圳市慧择保险经纪有限公司作为本人的保险经纪人，并委托深圳市慧择保险经纪有限公司全权代为办理保险相关事宜。
  3. 本投保人兹声明上述各项内容填写属实，并知道如果投保信息不真实，保险公司将有权拒赔，一切后果由本人承担。
  4. 本投保人已完整阅读本产品投保须知、详细条款，尤其是保障责任、免除责任、犹豫期、费用扣除、退保、保险单现金价值、投保人、被保险人义务的内容等各重要事项。本投保人特此同意接受该条款及投保须知之全部内容。
  5. 本投保人已明确了解该保险合同的成立、生效是以保险公司出具保单为准，确认非以支付保费为保险合同的成立要件。
  6. 本投保人已明确并接受本计划的承保机构、承保、保全变更、退保和理赔办理方式及理赔金支付方式。
  7. 根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同表现形式。本人接受保险公司在慧择保险提供的电子保单作为本投保书成立生效的合法有效凭证，具有完全证据效力。
  8. 本投保人已知晓并确认，投保本产品时如被保险人是未成年人, 其父母或监护人已知晓并同意投保人为该未成年人安排相关保险的承保。（如投保人已是未成年人的父母或监护人，则不适用于此条。）
      </pre>
    </div>
 </cube-popup>
</template>
<script type="text/ecmascript-6">
const COMPONENT_NAME = 'CubeExtendPopup'
export default {
  name: COMPONENT_NAME,
  // props: {
  //   content: {
  //     type: String
  //   }
  // },
  methods: {
    show() {
      this.$refs.popup.show()
    },
    hide() {
      this.$refs.popup.hide()
      this.$emit('hide')
    }
  }
}
</script>
<style lang="stylus" rel="stylesheet/stylus">
  .cube-extend-popup
    .cube-extend-popup-content
      padding: 20px
      color: #fff
      background-color: rgba(0, 0, 0, .8)
      .content
        font-size:28px;
        margin:20px;
        line-height: 1.2;
        text-align:justify;
        white-space: pre-wrap;
        overflow auto
        text-indent:50px
      .title
        text-align center
        font-size 36px; /*px*/
</style>



// WEBPACK FOOTER //
// src/components/CubeExtendPopup.vue